import type { EnrichedAnimalCategory } from "shared/types";

export const LIST_ENRICHED_FARM_CATEGORIES = "LIST_ENRICHED_FARM_CATEGORIES";

export type CategoryDispatchAction = {
  type: typeof LIST_ENRICHED_FARM_CATEGORIES;
  payload: { categories: EnrichedAnimalCategory[] };
};

export const listEnrichedFarmCategories = (
  categories: EnrichedAnimalCategory[]
): CategoryDispatchAction => {
  return {
    type: LIST_ENRICHED_FARM_CATEGORIES,
    payload: { categories },
  };
};
